export default __webpack_public_path__ + "static/home_bodegon_dominicana-0fefe120030741f9cd412caea7810c5b.png";